import { render, staticRenderFns } from "./Auth.vue?vue&type=template&id=642927ad&scoped=true&"
import script from "./Auth.vue?vue&type=script&lang=js&"
export * from "./Auth.vue?vue&type=script&lang=js&"
import style0 from "./Auth.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Auth.vue?vue&type=style&index=1&id=642927ad&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642927ad",
  null
  
)

export default component.exports